module.exports = {
      id: "payment-1-usage",
      viewBox: "0 0 43 45",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#payment-1-usage",
      toString: function () {
        return this.url;
      }
    }